import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CoordinatesModel, PaginationApplicationsResponse } from 'src/app/models/company.model';
import { SimplePaginationModel } from 'src/app/models/pagination.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { CompanyService } from 'src/app/services/company.service';

@Component({
  selector: 'app-list-applications',
  templateUrl: './list-applications.component.html',
  styleUrls: ['./list-applications.component.scss', './carousel.scss']
})
export class ListApplicationsComponent implements OnInit {
  onlyPending = true;
  page = 0;
  size = 5;
  app: PaginationApplicationsResponse;
  paginationApplications: SimplePaginationModel = new SimplePaginationModel(0, 6, 0, 0, 0);
  sizes = [6, 12, 36, 60];
  seeing = null;

  constructor(
    private companyService: CompanyService,
    private toastService: ToastrService
  ) {

  }

  ngOnInit(): void {
    this.getPaginationApplications();
  }

  getPaginationApplications() {
    this.companyService.getPaginationApplication(this.onlyPending, this.paginationApplications.page, this.paginationApplications.size).subscribe({
      next: (response: ResponseObject) => {
        var temp = response.data as PaginationApplicationsResponse;
        temp.resumeApplication.forEach(application => {
          var geo = application.application.geolocation;
          if (!geo.includes("null")) {
            application.application.coordinates = new CoordinatesModel(geo);
          }
        });
        this.app = temp;
        this.paginationApplications.total = this.app.total;
        var position = this.paginationApplications.page * this.paginationApplications.size;
        this.paginationApplications.start = position + 1;
        this.paginationApplications.end = position + this.app.resumeApplication.length;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }
}
